import {
  LinearProgress,
  Stack,
  Typography,
  alpha,
  linearProgressClasses,
  styled,
} from '@mui/material';
import Iconify from 'src/components/iconify/Iconify';
import type { DriveInfoPayload } from 'src/requests/drive';
import { calculateSpaceUsage } from './utils';

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: theme.spacing(1),
  borderRadius: theme.spacing(2),
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    border: '1px solid',
    borderColor: alpha(theme.palette.primary.main, 0.08),
  },
}));

const CustomStack = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1, 2, 3, 2),
  backgroundColor: alpha(theme.palette.primary.main, 0.08),
  width: '100%',
  height: theme.spacing(12),
  borderRadius: theme.spacing(1),
  color: theme.palette.text.disabled,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}));

type Props = {
  driveInfo: DriveInfoPayload;
};

export const DriveStorageCounter = ({ driveInfo }: Props) => {
  const { usedSpace, usedPercentage, totalSpace } = calculateSpaceUsage({
    usedSpaceBytes: driveInfo?.myDrive.usedSpace,
    totalSpaceBytes: driveInfo?.myDrive.totalSpace,
  });

  if (usedPercentage <= 75) {
    return null;
  }

  return (
    <Stack p={2}>
      <CustomStack spacing={0.5}>
        <Stack direction="row" spacing={1}>
          <Iconify icon="tabler:cloud" />
          <Typography variant="body2">Drive Usage Page</Typography>
        </Stack>
        <Stack spacing={0.5}>
          <BorderLinearProgress variant="determinate" value={usedPercentage} />
          <Stack direction="row" spacing={1}>
            <Typography variant="body2" color="primary">
              {usedSpace}
            </Typography>
            <Typography variant="body2"> of {totalSpace} used</Typography>
          </Stack>
        </Stack>
      </CustomStack>
    </Stack>
  );
};
